// Prepare a private upload locally; never change or upload the original file.
export const MAX_STUDIO_BYTES = 8 * 1024 * 1024;
const MAX_PIXELS = 24000000;
const readData = blob => new Promise((resolve, reject) => {
 const reader = new FileReader();
 reader.onload = () => resolve(reader.result.split(',')[1]);
 reader.onerror = () => reject(new Error('No se pudo leer la imagen.'));
 reader.readAsDataURL(blob);
});
export async function prepareStudioImage(file) {
 if (!file.size || file.size > 100 * 1024 * 1024) throw Error('Selecciona una foto de hasta 100 MB.');
 let bitmap;
 try { bitmap = await createImageBitmap(file, {imageOrientation:'from-image'}); }
 catch { throw Error('No se pudo abrir la foto. Usa JPEG, PNG o WebP.'); }
 try {
  const {width,height} = bitmap;
  const head = new Uint8Array(await file.slice(0,12).arrayBuffer());
  const mime = head[0]===255&&head[1]===216?'image/jpeg':head[0]===137&&head[1]===80?'image/png':String.fromCharCode(...head.slice(0,4))==='RIFF'&&String.fromCharCode(...head.slice(8,12))==='WEBP'?'image/webp':null;
  if (!mime) throw Error('Formato no compatible. Usa JPEG, PNG o WebP.');
  let blob=file;
  if (file.size > MAX_STUDIO_BYTES || width*height > MAX_PIXELS) {
   let scale=Math.min(1,Math.sqrt(MAX_PIXELS/(width*height)),8192/Math.max(width,height));
   const canvas=document.createElement('canvas');
   const outputMime=mime==='image/jpeg'?'image/jpeg':'image/webp';
   for(let pass=0;pass<12;pass++) {
    canvas.width=Math.max(1,Math.floor(width*scale));canvas.height=Math.max(1,Math.floor(height*scale));
    const ctx=canvas.getContext('2d');if(!ctx)throw Error('No se pudo preparar la foto.');
    ctx.drawImage(bitmap,0,0,canvas.width,canvas.height);
    for(const quality of [.94,.88,.8,.7]) {
     blob=await new Promise(resolve=>canvas.toBlob(resolve,outputMime,quality));
     if(!blob)throw Error('No se pudo reducir la foto.');
     if(blob.size<=MAX_STUDIO_BYTES) break;
    }
    if(blob.size<=MAX_STUDIO_BYTES)break;
    scale*=.8;
   }
   canvas.width=canvas.height=1;
  }
  if(blob.size>MAX_STUDIO_BYTES)throw Error('No se pudo ajustar la foto a 8 MB.');
  return {input:{image_b64:await readData(blob),image_mime_type:blob===file?mime:blob.type},originalBytes:file.size,sentBytes:blob.size,adjusted:blob!==file};
 } finally { bitmap.close(); }
}
